
import { Box } from "@chakra-ui/react";

import WaitingTimePerServiceTable from "../../../organization/tables/daily/WaitingTimePerServiceTable";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { buildDurationInsights } from "../../../../store/reportEnterpriseInsights";
import { formatTime } from "../../../../store/helpers";

const BranchWaitingTimePerService = ({
  branchId = null,
  reportIndex,
  branchIndex,
  data,
  numServices = 0,
  branchName = "",
  renderConfig,
}) => {
  const insights = buildDurationInsights(data, {
    metric: "waiting",
    scopeLabel: "Service",
    formatDuration: formatTime,
  });

  return (
    <Box>
      <EnterpriseReportSummary
        title="Daily Service Waiting Time Summary"
        kpis={insights.kpis}
        tables={insights.tables}
        notes={insights.notes}
      />
      <WaitingTimePerServiceTable
        branchId={branchId}
        data={data}
        numServices={numServices}
        branchName={branchName}
        reportIndex={reportIndex}
        branchIndex={branchIndex}
        renderConfig={renderConfig}
      />
    </Box>
  );
};

export default BranchWaitingTimePerService;
